import { TELEMETRY_ENABLED } from "../constants";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { useHistory } from "react-router";


let appInsights = null;

const useTelemetry = () => {

  const history = useHistory();

  const start = (telemetryKey) => {
    if (!TELEMETRY_ENABLED) return;

    const reactPlugin = new ReactPlugin();
    
    appInsights = new ApplicationInsights({
      config: {
          connectionString: telemetryKey,
          enableAutoRouteTracking: true,
          enableCorsCorrelation: true,
          extensions: [reactPlugin],
          extensionConfig: {
            [reactPlugin.identifier]: { history: history }
          }
      }
    });

    appInsights.loadAppInsights();
  };

  const setContext = (user) => {
    try{
      if (TELEMETRY_ENABLED && appInsights) {
        appInsights.setAuthenticatedUserContext(user.username, String(user.id));
      }
    }
    catch(e) {
      console.error(e);
    }
  };

  const clearContext = () => {
    try{
      if (TELEMETRY_ENABLED && appInsights) {
        appInsights.clearAuthenticatedUserContext();
      }
    }
    catch(e) {
      console.error(e);
    }
  };

  return { start, setContext, clearContext };
};

export default useTelemetry;
